<aside class="flex flex-col gap-6">
  <ng-content select="[seeothers]"></ng-content>
  <ng-content select="[booktimenow]"></ng-content>
  <ng-content select="[reviews]"></ng-content>

  <!--  @if (loadDoktorseRecept() === true) {-->
  <!--    <app-doktorse-recept-banner />-->
  <!--  }-->

  @if (isAdVisible() === true) {
    <div class="sidebar-banners-container">
      <app-standard-dfp-banner-loader
        [reloadCallback]="ad1aReloadCallback"
        [size]="[[320, 600]]"
        [unitName]="'/56297020/RIGHT_BANNER_1a'"
      ></app-standard-dfp-banner-loader>

      <app-standard-dfp-banner-loader
        [reloadCallback]="ad2aReloadCallback"
        [size]="[[320, 600]]"
        [unitName]="'/56297020/RIGHT_BANNER_2a'"
      ></app-standard-dfp-banner-loader>

      @if (isAdPlaceholderActive() === true) {
        <app-sidebar-ad-placeholder />
      }
    </div>
  }

  <ng-content select="[faq]"></ng-content>

  @if (isPuffVisible() === true) {
    <app-sidebar-puffs-list [pageType]="pageType()" />
  }
</aside>
